import {
  KIOSK_OPERATOR_NAME_STORAGE_KEY,
  KIOSK_SELECTED_REGISTER_STORAGE_KEY,
} from './kioskConstants';

export function loadStoredSelectedRegisterId() {
  if (
    typeof window === 'undefined'
    || !window.localStorage
    || typeof window.localStorage.getItem !== 'function'
  ) {
    return '';
  }

  return window.localStorage.getItem(KIOSK_SELECTED_REGISTER_STORAGE_KEY) ?? '';
}

export function loadStoredOperatorName() {
  if (
    typeof window === 'undefined'
    || !window.localStorage
    || typeof window.localStorage.getItem !== 'function'
  ) {
    return '';
  }

  return window.localStorage.getItem(KIOSK_OPERATOR_NAME_STORAGE_KEY) ?? '';
}

export function storeSelectedRegisterId(registerId) {
  if (
    typeof window === 'undefined'
    || !window.localStorage
  ) {
    return;
  }

  if (registerId) {
    if (typeof window.localStorage.setItem === 'function') {
      window.localStorage.setItem(KIOSK_SELECTED_REGISTER_STORAGE_KEY, registerId);
    }
    return;
  }

  if (typeof window.localStorage.removeItem === 'function') {
    window.localStorage.removeItem(KIOSK_SELECTED_REGISTER_STORAGE_KEY);
  }
}

export function storeOperatorName(operatorName) {
  if (
    typeof window === 'undefined'
    || !window.localStorage
  ) {
    return;
  }

  if (operatorName) {
    if (typeof window.localStorage.setItem === 'function') {
      window.localStorage.setItem(KIOSK_OPERATOR_NAME_STORAGE_KEY, operatorName);
    }
    return;
  }

  if (typeof window.localStorage.removeItem === 'function') {
    window.localStorage.removeItem(KIOSK_OPERATOR_NAME_STORAGE_KEY);
  }
}
